const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

export function motionScrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? "auto" : "smooth";
}

export function scrollIntoViewMotionSafe(
  element: Element,
  options: Omit<ScrollIntoViewOptions, "behavior"> = {},
): void {
  element.scrollIntoView({ ...options, behavior: motionScrollBehavior() });
}

export function scrollToMotionSafe(
  target: Window | Element,
  options: Omit<ScrollToOptions, "behavior">,
): void {
  target.scrollTo({ ...options, behavior: motionScrollBehavior() });
}

export function scrollByMotionSafe(
  target: Window | Element,
  options: Omit<ScrollToOptions, "behavior">,
): void {
  target.scrollBy({ ...options, behavior: motionScrollBehavior() });
}

export function motionDuration(durationMs: number): number {
  return prefersReducedMotion() ? 0 : durationMs;
}

const SECTION_HIGHLIGHT_CLASSES = ["ring-2", "ring-primary", "ring-offset-2"];
const SECTION_HIGHLIGHT_MS = 2000;

export function flashSectionHighlight(sectionId: string): void {
  const element = document.getElementById(sectionId);
  if (!element) return;
  scrollIntoViewMotionSafe(element, { block: "center" });
  element.classList.add(...SECTION_HIGHLIGHT_CLASSES);
  window.setTimeout(() => {
    element.classList.remove(...SECTION_HIGHLIGHT_CLASSES);
  }, SECTION_HIGHLIGHT_MS);
}

const PULSE_CLASSES = ["animate-pulse", "ring-2", "ring-warning", "rounded-md"];
const PULSE_MS = 2000;

export function pulseElements(elementIds: string[]): void {
  for (const elementId of elementIds) {
    const element = document.getElementById(elementId);
    if (!element) continue;
    element.classList.add(...PULSE_CLASSES);
    window.setTimeout(() => {
      element.classList.remove(...PULSE_CLASSES);
    }, PULSE_MS);
  }
}
